// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Lookup } from './lookup';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class LookupList extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  lookupListId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  lbound!: number;
  locationId!: number;
  ts!: string;
  ubound!: number;
  updatedBy!: string;
  updatedDate!: Date;
  lookups!: Lookup[];
}

